import { Route } from "react-router-dom";

import Reports from "../../Modules/Admin/Screens/Reports/Reports";
import ReportType from "../../Modules/Admin/Screens/Reports/ReportType";
import AssignmentCampusListing from "../../Modules/Admin/Screens/Reports/AssignmentCampusListing";
import AssignmentListing from "../../Modules/Admin/Screens/Reports/AssignmentListing";
import ModuleCampusListing from "../../Modules/Admin/Screens/Module/ModuleCampusListing";
import ModuleListing from "../../Modules/Admin/Screens/Module/ModuleListing";
import ModuleReport from "../../Modules/Admin/Screens/Module/ModuleReport";
import ReportList from "../../Modules/Admin/Screens/Module/ReportList";
import LeetcodeClusterListing from "../../Modules/Admin/Screens/Reports/LeetcodeClusterListing";
import LeetcodeReportDetails from "../../Modules/Admin/Screens/Reports/LeetcodeReportDetails.jsx";
import ReportMessage from "../../Modules/Admin/Screens/Reports/ReportMessage.jsx";


const ReportRoutes =[
  <Route key="reports" path="/admin/reports" element={<Reports />} />,
  <Route
    key="assignment-campus-listing"
    path="/admin/reports/assignment"
    element={<AssignmentCampusListing />}
  />,
  <Route
    key="assignment-listing"
    path="/admin/reports/assignments/:campusName"
    element={<AssignmentListing />}
  />,
  <Route
    key="module-campus-listing"
    path="/admin/reports/module"
    element={<ModuleCampusListing />}
  />,
  <Route
    key="leetcode-campus"
    path="/admin/reports/leetcode/:campusName"
    element={<LeetcodeClusterListing />}
  />,
  <Route
    key="leetcode-report"
    path="/admin/reports/leetcode/:campusName/:clusterId"
    element={<LeetcodeReportDetails />}
  />,
  <Route
    key="module-listing"
    path="/admin/reports/module/:campusName"
    element={<ModuleListing />}
  />,
  <Route
    key="module-report"
    path="/admin/reports/module/:campusName/:moduleId"
    element={<ModuleReport />}
  />,
  <Route
    key="module-detailed-report"
    path="/admin/reports/module/:campusName/:moduleId/report"
    element={<ReportList />}
  />,
  <Route
    key="report-message"
    path="/admin/reports/report-message/:campusName?"
    element={<ReportMessage />}
  />,
  <Route
    key="campus-reports"
    path="/admin/reports/:campusName"
    element={<ReportType />}
  />,
];

export default ReportRoutes;
